import axios from "axios";

export const getAuditListAPI = (page, size, caseId) => {
    return axios.get(`/audit/get-list`, {params: {page, size, caseId}});
};

export const getDownURL = ( caseId) => {
    return axios.post(`/audit/get-down-url`, {caseId});
};

export const getCaseId = () => {
    return axios.get(`/audit/get-case-id`);
};